import { gql } from '@apollo/client'

/** A row on Partner Signups (and the header of one application's page). */
const SIGNUP_ROW_FIELDS = `
  _id
  restaurantName
  dbaAddressLine1
  dbaAddressLine2
  dbaCity
  dbaState
  restaurantPhone
  restaurantEmail
  website
  contactName
  contactEmail
  contactPhone
  corporateName
  corpAddressLine1
  corpAddressLine2
  corpCity
  corpState
  corpZip
  taxId
  hasOnlineOrdering
  doordashRate
  ubereatsRate
  grubhubRate
  agreedToTerms
  agreedAt
  interestedInPos
  status
  notes
  createdAt
  updatedAt
  isApplication
  legalName
  signerName
  signedAt
  restaurantId
  businessType
  agentName
  pricingStatus
  held
  startedByName
  canDelete
  progress { done total next }
`

export const GET_PARTNER_SIGNUPS = gql`
  query PartnerSignups {
    partnerSignups { ${SIGNUP_ROW_FIELDS} }
  }
`

export const GET_PARTNER_SIGNUP = gql`
  query PartnerSignup($id: ID!) {
    partnerSignup(id: $id) { ${SIGNUP_ROW_FIELDS} }
  }
`

export const UPDATE_STATUS = gql`
  mutation UpdatePartnerSignupStatus($id: ID!, $status: String!, $notes: String) {
    updatePartnerSignupStatus(id: $id, status: $status, notes: $notes) {
      _id
      status
      notes
    }
  }
`

/** "5/21/2026, 10:31:37 AM" from an ISO string, epoch millis or a MySQL datetime. */
export function formatDate(value) {
  if (!value) return '—'
  // Support ISO strings, epoch millis (number or numeric string), and
  // MySQL "YYYY-MM-DD HH:mm:ss" (which some browsers fail to parse).
  let d = new Date(value)
  if (isNaN(d.getTime()) && /^\d+$/.test(String(value))) {
    d = new Date(Number(value))
  }
  if (isNaN(d.getTime()) && typeof value === 'string') {
    d = new Date(value.replace(' ', 'T'))
  }
  return isNaN(d.getTime()) ? '—' : d.toLocaleString()
}
